import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {Location} from '@angular/common';
import {StoreItemActions} from "../../../../../../store/entities/store-item/store-item.actions";
import {StoreItemEntity} from "../../../../../../store/entities/store-item/store-item.model";
import {select, Store} from "@ngrx/store";
import {
  selectStoreItems
} from "../../../../../../store/entities/store-item/store-item.selectors";
import {Observable} from "rxjs";
import {GET_ABOUT_US} from "../../../../../../store/entities/cms/about-us/about-us.graphql";
import {AboutUs} from "../../../../../../store/entities/cms/about-us/about-us.model";
import {GET_BENEFITS} from "../../../../../../store/entities/cms/benefit/benefit.graphql";
import {Benefit} from "../../../../../../store/entities/cms/benefit/benefit.model";
import {Objective} from "../../../../../../store/entities/cms/objective/objective.model";
import {GET_OBJECTIVES} from "../../../../../../store/entities/cms/objective/objective.graphql";
import {AppState} from "../../../../../../store/reducers";

@Component({
  selector: 'app-about-tgsd',
  templateUrl: './about-tgsd.component.html',
  styleUrls: ['./about-tgsd.component.scss']
})
export class AboutTgsdComponent implements OnInit {

  constructor(private location: Location,private store: Store<AppState>) { }
  @Output() exitHover = new EventEmitter();
  aboutUs$: Observable<AboutUs[]>;
  benefit$: Observable<Benefit[]>;
  objective$: Observable<Objective[]>;

  ngOnInit() {
    this.store.dispatch(StoreItemActions.getStoreItemsMergeMap({ entity: StoreItemEntity.aboutUs, query: GET_ABOUT_US, filtering: {} }));
    this.aboutUs$ = this.store.pipe(select(selectStoreItems(StoreItemEntity.aboutUs)));

    this.store.dispatch(StoreItemActions.getStoreItemsMergeMap({ entity: StoreItemEntity.objective, query: GET_OBJECTIVES, filtering: {} }));
    this.objective$ = this.store.pipe(select(selectStoreItems(StoreItemEntity.objective)));

    this.store.dispatch(StoreItemActions.getStoreItemsMergeMap({ entity: StoreItemEntity.benefit, query: GET_BENEFITS, filtering: {} }));
    this.benefit$ = this.store.pipe(select(selectStoreItems(StoreItemEntity.benefit)));
  }

  goBack() {
    this.location.back()
  }
}
